/**
 * Anchor IDs for the Home page (single section; no sidebar TOC required but kept for consistency if expanded).
 */
export const HOME_PAGE_TOP_SECTIONS = [{ id: "home-overview", label: "Home" }];

/**
 * Anchor IDs for the Products page table of contents. Article headings still emit `home-*` ids from markdown.
 */
export const PRODUCT_PAGE_TOP_SECTIONS = [
  { id: "products-overview", label: "Overview" },
  { id: "home-control-plane", label: "1. The Control Plane" },
  { id: "home-observing-control-plane", label: "2. Observing the Control Plane" },
];

export const HOME_PAGE_LLM_BRANCH = {
  label: "LLM & auditability",
  items: [
    { id: "home-llm-component", label: "3. The LLM Component" },
    { id: "home-llm-secure", label: "3.1 It is Secure" },
    { id: "home-llm-audit-query", label: "3.2 It is Auditable (Query)" },
    { id: "home-llm-audit-update", label: "3.3 It is Auditable (Update)" },
    { id: "home-llm-runtime", label: "3.4 It is Your Own Runtime" },
  ],
};
